
import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeView",
  
  data() {
    return {
      companyName: "",
      companyIconFileName: "",
      whatsappNumber: "",
      isLogginSuccessfull: false,

      // Carousel variables
      Car_Image_Width: 640,
      Car_Image_Height: 425,
      Car_Border: true,
      Car_Border_Color: "white",
      Car_Speed: 2,
      Car_Direction: true,
      Car_NoOfSides: 12,
      C_HalfNo: 6,

      CW_I: new Array(1),
      C_ClcW: new Array(0),

      C_Coef: [
        (3 * Math.PI) / 2,
        0,
        (3 * Math.PI) / 2,
        (11 * Math.PI) / 6,
        Math.PI / 6,
        (3 * Math.PI) / 2,
        (7 * Math.PI) / 4,
        0,
        Math.PI / 4,
        (3 * Math.PI) / 2,
        (5 * Math.PI) / 3,
        (11 * Math.PI) / 6,
        0,
        Math.PI / 6,
        Math.PI / 3,
      ],

      Car_Image_Sources: [
        "Security Camera Room.jfif",
        "security.html",
        "Gate SecurityOfficer.jfif",
        "camera.html",
        "Man with Lock.jpg",
        "security.html",
        "Long Camera.jfif",
        "",
        "Building security.jfif",
        "security.html",
        "Carpark Security.jfif",
        "carparksecurity.html",
      ],

      C_CoefOf: 9,
      C_Pre_Img: new Array(4),
      C_Angle: 0,
      C_CrImg: 12,
      C_MaxW: 0,
      C_TotalW: 0,
      C_Stppd: false,
      i: 0,
      C_LeftOffset: 0,
    };
  },
  
  methods: {
    loadBranding() {
      // Get data from localStorage (set by app.vue)
      this.companyName = localStorage.getItem("companyNameForHeader") || "";
      this.companyIconFileName = localStorage.getItem("companyIconFile") || "";
      
      const whatsappRaw = localStorage.getItem("whatsappNumber") || "";
      if (whatsappRaw && whatsappRaw !== "") {
        const digits = whatsappRaw.toString().replace(/\D/g, "");
        this.whatsappNumber = "https://wa.me/" + digits;
      }
    },
    
    handleBrandingLoaded() {
      this.loadBranding();
    },
    
    Carousel() {
      if (document.getElementById("Carousel")) {
        for (var i = 0; i < this.Car_Image_Sources.length; i += 2) {
          this.C_Pre_Img[i] = new Image();
          this.C_Pre_Img[i].src = this.Car_Image_Sources[i];
        }

        this.C_MaxW =
          this.Car_Image_Width / Math.sin(Math.PI / this.Car_NoOfSides) +
          this.C_HalfNo +
          1;

        var Car_Div = document.getElementById("Carousel");
        for (let i = 0; i < this.C_HalfNo; i++) {
          this.CW_I[i] = document.createElement("img");
          Car_Div?.appendChild(this.CW_I[i]);
          this.CW_I[i].style.position = "absolute";
          this.CW_I[i].style.top = 0 + "px";
          this.CW_I[i].style.height = this.Car_Image_Height + "px";

          if (this.Car_Border) {
            this.CW_I[i].style.borderStyle = "solid";
            this.CW_I[i].style.borderWidth = 1 + "px";
            this.CW_I[i].style.borderColor = this.Car_Border_Color;
          }

          this.CW_I[i].src = this.Car_Image_Sources[2 * i];
          this.CW_I[i].lnk = this.Car_Image_Sources[2 * i + 1];

          this.CW_I[i].addEventListener("mouseover", () => {
            this.CW_I[i].style.cursor = this.CW_I[i].lnk ? "pointer" : "default";
            this.C_Stppd = true;
          });

          this.CW_I[i].addEventListener("mouseout", () => {
            this.CW_I[i].style.cursor = this.CW_I[i].lnk ? "pointer" : "default";
            this.C_Stppd = false;
          });
        }

        this.CW_I[0].src = "Event Security3.png";

        setInterval(() => {
          this.CarImages();
        }, 50);
      }
    },
    
    C_Stp() {
      this.C_Stppd = true;
    },
    
    C_Rstrt() {
      this.C_Stppd = false;
    },
    
    CarImages() {
      if (!this.C_Stppd) {
        this.C_TotalW = 0;
        for (let i = 0; i < this.C_HalfNo; i++) {
          this.C_ClcW[i] = Math.round(
            Math.cos(Math.abs(this.C_Coef[this.C_CoefOf + i] + this.C_Angle)) *
              this.Car_Image_Width
          );
          this.C_TotalW += this.C_ClcW[i];
        }
        this.C_LeftOffset = (this.C_MaxW - this.C_TotalW) / 2;
        for (let i = 0; i < this.C_HalfNo; i++) {
          this.CW_I[i].style.left = this.C_LeftOffset + "px";
          this.CW_I[i].style.width = this.C_ClcW[i] + "px";
          this.C_LeftOffset += this.C_ClcW[i];
        }
        this.C_Angle +=
          (this.Car_Speed / 720) * Math.PI * (this.Car_Direction ? -1 : 1);
        if (
          (this.Car_Direction && this.C_Angle <= 0) ||
          (!this.Car_Direction && this.C_Angle >= Math.PI / this.C_HalfNo)
        ) {
          if (this.C_CrImg == this.Car_Image_Sources.length) this.C_CrImg = 0;

          if (this.Car_Direction) {
            this.CW_I[this.C_HalfNo] = this.CW_I[0];

            for (let i = 0; i < this.C_HalfNo; i++)
              this.CW_I[i] = this.CW_I[i + 1];

          } else {
            for (let i = 4; i > 0; i--) this.CW_I[i] = this.CW_I[i - 1];
            this.CW_I[0] = this.CW_I[this.C_HalfNo];
            this.CW_I[0].src = this.Car_Image_Sources[this.C_CrImg];
            this.CW_I[0].lnk = this.Car_Image_Sources[this.C_CrImg + 1];
          }
          this.C_Angle = this.Car_Direction ? Math.PI / this.C_HalfNo : 0;
          this.C_CrImg = this.C_CrImg + 2;
        }
      }
    },
  },
  
  mounted() {
    // Load branding immediately
    this.loadBranding();
    
    // Listen for branding loaded event from app.vue
    window.addEventListener('brandingLoaded', this.handleBrandingLoaded);
    
    // Set C_HalfNo dynamically
    this.C_HalfNo = this.Car_NoOfSides / 2;
    
    // Initialize carousel
    this.$nextTick(() => {
      this.Carousel();
    });
  },
  
  beforeUnmount() {
    window.removeEventListener('brandingLoaded', this.handleBrandingLoaded);
  },
});
